/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function variantATC() {
  var addVariantBtn = document.querySelectorAll('[data-variant-add]');
  var variantToggleBtn = document.querySelectorAll('[data-variant-toggle]');
  var cartDrawerBtn = document.querySelector('.js-cart');

  addVariantBtn.forEach(function(addVariantBtn) {
    console.log('variant button');
    addVariantBtn.addEventListener('click', function(evt) {
      evt.preventDefault();

      console.log('click');
      
      var variantId = this.getAttribute('data-variant-add');
      
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      
      fetch(window.routes.cartAddUrl + '.js', {
        body: JSON.stringify({ id: variantId, quantity: 1 }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        }
      }).then(function (response) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        if (response.ok) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
          if (addVariantBtn.parentElement.previousElementSibling.classList.contains('Button')) {
            addVariantBtn.parentElement.style.display = 'none';
            addVariantBtn.parentElement.previousElementSibling.style.display = '';
          }
          setTimeout(function(){ cartDrawerBtn.click(); }, 250);
        } else {
          response.json().then(function (content) {
            alert('Error: ' + content['description'])
          });
        }
      });
    });
  });

  variantToggleBtn.forEach(function(variantToggleBtn) {
    variantToggleBtn.addEventListener('click', function(evt) {
      evt.preventDefault();
      
      this.style.display = 'none';
      this.nextElementSibling.style.display = 'block';
    });
  });
}

window.addEventListener('DOMContentLoaded', function(e) {
  
  variantATC();

  // Age check on cart template
  document.addEventListener('click', function(evt) {
    if (evt.target.id == 'age-check') {
      var checked = evt.target.checked;
      var checkoutBtn = document.querySelector('button[name="checkout"]');
      var ageCheck = document.querySelector('[dewsign-age-check]');

      if (checked) {
        checkoutBtn.disabled = false;
        ageCheck.classList.remove('Dewsign-CartCheck--warning');
        ageCheck.classList.add('Dewsign-CartCheck--success');
      } else {
        checkoutBtn.disabled = true;
        ageCheck.classList.add('Dewsign-CartCheck--warning');
        ageCheck.classList.remove('Dewsign-CartCheck--success');
      }
    }
  });

  window.onscroll = function() {sticky()};
  var navbar = document.querySelector(".Header__MainNav");
  var stickyNavBar = navbar.offsetTop;
  var search = document.querySelector("#Search");
  var headerOffset = document.querySelector('.Header__Wrapper').offsetHeight;
  var searchInput = document.querySelector('.Search__Input');
  var closeSearch = document.querySelector('.Search__Close');
  var searchResults = document.querySelector('.Search__Results');

  closeSearch.addEventListener('click', function() {
    searchInput.value = '';
    searchInput.dispatchEvent(new Event('change'));
    searchResults.setAttribute('aria-hidden', true);
    document.querySelector('html').classList.remove('no-scroll');
  });

  function sticky() {
    if (window.pageYOffset >= stickyNavBar) {
      navbar.classList.add("Header__MainNav--sticky")
    } else {
      navbar.classList.remove("Header__MainNav--sticky");
    }

    if (window.pageYOffset >= headerOffset) {
      search.setAttribute('aria-hidden', false);
      search.classList.add('Search--fixed');
    } else {
      search.setAttribute('aria-hidden', true);
      search.classList.remove('Search--fixed');
    }
  }

  document.querySelector('.Search__Input').addEventListener('keyup', function(e) {
    document.querySelector('html').classList.add('no-scroll');
  });
});